if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector('.product-images') ? this.productWrapper.querySelector('.product-images') : this.productWrapper.querySelector('.product-quick-images');
        this.thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.bindCeramicQuantity();
      setTimeout(() => {
        this.updateCeramicInfo();
      }, 0);
    }

    async onVariantChange() {
      this.updateOptions();
      await this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();

        setTimeout(() => {
          this.updateCeramicInfo();
          this.updateMedia();
        }, 0);
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }

    async updateMasterId() {
      try {
        const data = this.getVariantData();
        const found = data.find((variant) => {
          return !variant.options.map((opt, idx) => this.options[idx] === opt).includes(false);
        });
        if (found) {
          this.currentVariant = found;
          return;
        }
      } catch (e) {}

      const sectionId = this.dataset.section;
      const url = new URL(this.dataset.url, window.location.origin);

      const ids = [];
      this.querySelectorAll('input[data-option-value-id]:checked')
        .forEach((el) => ids.push(el.dataset.optionValueId));

      this.querySelectorAll('select').forEach((sel) => {
        const opt = sel.selectedOptions && sel.selectedOptions[0];
        if (opt?.dataset?.optionValueId) ids.push(opt.dataset.optionValueId);
      });

      const uniqueIds = [...new Set(ids)].filter(Boolean);

      url.searchParams.set('section_id', sectionId);
      if (uniqueIds.length) url.searchParams.set('option_values', uniqueIds.join(','));

      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      this._hvDoc = doc;

      const input =
        doc.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
        doc.querySelector('form[action*="/cart/add"] input[name="id"]') ||
        doc.querySelector('input[name="id"]');

      const variantId = input?.value;

      if (variantId) {
        const disabledBtn =
          doc.querySelector('.single-add-to-cart-button[disabled]') ||
          doc.querySelector('button[name="add"][disabled]');
        const vid = Number(variantId);

        let fullVariant = null;
        try {
          const data = this.getVariantData();
          fullVariant = data.find(v => Number(v.id) === vid) || null;
        } catch (e) {}

        if (fullVariant) {
          fullVariant.available = !disabledBtn;
          this.currentVariant = fullVariant;
        } else {
          this.currentVariant = { id: vid, available: !disabledBtn };
        }

        if (this.updateUrl && variantId) {
          window.history.replaceState({}, '', `${this.dataset.url}?variant=${variantId}`);
        }

        const forms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
        forms.forEach((f) => {
          const idInput = f.querySelector('input[name="id"]');
          if (idInput) {
            idInput.value = Number(variantId);
            idInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      } else {
        this.currentVariant = null;
      }

      console.log('[HV] option_values:', uniqueIds.join(','));
      console.log('[HV] fetched variantId:', variantId);
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.productSlider) return;

      if (this.currentVariant.featured_media && this.currentVariant.featured_media.id) {
        const mediaId = `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`;
        const activeMedia = this.productSlider.querySelector(mediaId);
        if (activeMedia) this.setActiveMedia(activeMedia);
        return;
      }

      const imageId =
        this.currentVariant.featured_image?.id ||
        this.currentVariant.image_id ||
        null;

      if (!imageId) return;

      const mediaId = `#Slide-${this.dataset.section}-${imageId}`;
      const activeMedia = this.productSlider.querySelector(mediaId);

      if (activeMedia) {
        this.productSlider.querySelectorAll('.product-images__slide.is-active')
          .forEach(el => el.classList.remove('is-active'));

        activeMedia.classList.add('is-active');
        activeMedia.parentElement.prepend(activeMedia);
      }
    }

    setActiveMedia(activeMedia) {
      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      activeMedia.classList.add('is-active');
      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }
    }

    setActiveMediaSlider(mediaId, thumbId, productSlider) {
      let flkty = productSlider.flkty,
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });
        if (this.thumbnails) {
          if (this.thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            this.thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(this.thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });
        }

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (this.thumbnails) {
          let activeThumb = this.thumbnails.querySelector(thumbId);

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

   updateCeramicInfo() {
  if (!this.currentVariant) return;

  const productRoot =
    this.closest('.product-information') ||
    this.closest('.thb-product-detail') ||
    document.getElementById(`ProductInfo-${this.dataset.section}`) ||
    this.closest('[id^="ProductInfo-"]') ||
    document;

  const priceEl = document.getElementById(`ceramic-m2-price-${this.dataset.section}`);
  const totalEl = document.getElementById(`ceramic-total-m2-${this.dataset.section}`);
  const dataEl = productRoot.querySelector('.seramik-variant-data');

 const formId = `product-form-${this.dataset.section}`;
const qtyInput =
  document.querySelector(`input[name="quantity"][form="${formId}"], input.qty[form="${formId}"]`) ||
  this.closest('.thb-product-detail')?.querySelector('input.qty, input[name="quantity"]');
  if (!priceEl && !totalEl) return;

  let currentData = null;

  if (dataEl) {
    try {
      const allData = JSON.parse(dataEl.textContent);
      currentData = allData.find((v) => String(v.id) === String(this.currentVariant.id)) || null;
    } catch (e) {}
  }

  const rawM2 = currentData?.m2_fiyati ?? this.currentVariant.m2_fiyati ?? this.currentVariant.metafields?.custom?.m2_fiyati?.value ?? 0;
  const rawPaket = currentData?.paket_m2 ?? this.currentVariant.paket_m2 ?? this.currentVariant.metafields?.custom?.paket_m2?.value ?? 0;

  const m2Fiyati = parseFloat(String(rawM2).replace(',', '.')) || 0;
  const paketM2 = parseFloat(String(rawPaket).replace(',', '.')) || 0;
  const qty = qtyInput ? (parseInt(qtyInput.value || '1', 10) || 1) : 1;

  let shownM2Price = 0;
  if (m2Fiyati > 0) {
    shownM2Price = m2Fiyati;
  } else if (paketM2 > 0 && this.currentVariant.price) {
    shownM2Price = (parseFloat(this.currentVariant.price) / 100) / paketM2;
  }

  if (priceEl) {
    if (shownM2Price > 0) {
      priceEl.textContent =
        'm² fiyatı: ' +
        new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(shownM2Price) +
        ' ₺';
    } else {
      priceEl.textContent = '';
    }
  }

  if (totalEl) {
    if (paketM2 > 0) {
      totalEl.dataset.paketM2 = paketM2;
      const totalM2 = paketM2 * qty;
      totalEl.textContent = 'Toplam: ' + totalM2.toFixed(2).replace('.', ',') + ' m²';
    } else {
      totalEl.textContent = '';
    }
  }
}

   bindCeramicQuantity() {
  if (window.__ceramicQtyListenerBound) return;
  window.__ceramicQtyListenerBound = true;

  const updateFromInput = (input) => {
    if (!input) return;

    const formId = input.getAttribute('form');
    if (!formId) return;

    const section = formId.replace('product-form-', '');
    const variantSelect = document.querySelector(`variant-selects[data-section="${section}"]`);

    if (!variantSelect) return;

    setTimeout(() => {
      variantSelect.updateCeramicInfo();
    }, 0);
  };

  document.addEventListener('input', (e) => {
    if (e.target.matches('input.qty, input[name="quantity"]')) {
      updateFromInput(e.target);
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('input.qty, input[name="quantity"]')) {
      updateFromInput(e.target);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.plus') || e.target.closest('.minus')) {
      const wrapper = e.target.closest('.quantity') || e.target.closest('.quantity__wrapper') || e.target.closest('.product-form__quantity') || document;
      const input = wrapper.querySelector('input.qty, input[name="quantity"]') || document.activeElement;
      setTimeout(() => {
        updateFromInput(input);
      }, 50);
    }
  });
}

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      const sections = this.getSectionsToRender();

      if (this._hvDoc) {
        sections.forEach((id) => {
          const destination = document.getElementById(id);
          const source = this._hvDoc.getElementById(id);

          if (source && destination) destination.innerHTML = source.innerHTML;

          const price = document.getElementById(id);
          const price_fixed = document.getElementById(id + '--sticky');

          if (price) price.classList.remove('visibility-hidden');
          if (price_fixed) price_fixed.classList.remove('visibility-hidden');
        });

        this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        setTimeout(() => {
          this.updateCeramicInfo();
        }, 0);

        this._hvDoc = null;
        return;
      }

      fetch(this.dataset.url + '?variant=' + this.currentVariant.id + '&section_id=' + this.dataset.section)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');
          });

          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

          setTimeout(() => {
            this.updateCeramicInfo();
          }, 0);

          const fullUrl = this.dataset.url + '?variant=' + this.currentVariant.id;

          fetch(fullUrl, { credentials: 'same-origin' })
            .then(r => r.text())
            .then(fullText => {
              const fullDoc = new DOMParser().parseFromString(fullText, 'text/html');

              const srcSlide =
                fullDoc.querySelector('.product-images__slide.is-active') ||
                fullDoc.querySelector('.product-images__slide');

              const srcImg = srcSlide?.querySelector('img');
              if (!srcImg) return;

              const destSlide =
                this.productWrapper?.querySelector('.product-images__slide.is-active') ||
                this.productWrapper?.querySelector('.product-images__slide');

              const destImg = destSlide?.querySelector('img');
              if (!destImg) return;

              const copyAttr = (name) => {
                const v = srcImg.getAttribute(name);
                if (v != null) destImg.setAttribute(name, v);
              };

              copyAttr('src');
              copyAttr('srcset');
              copyAttr('sizes');
              copyAttr('data-src');
              copyAttr('data-srcset');
              copyAttr('data-sizes');

              destImg.classList.remove('lazyload');
              destImg.classList.add('lazyloaded');

              if (srcSlide?.id && destSlide) {
                this.productWrapper
                  ?.querySelectorAll('.product-images__slide.is-active')
                  .forEach(el => el.classList.remove('is-active'));

                destSlide.classList.add('is-active');
              }
            })
            .catch(() => {});
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data) {
        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                value: this.options[0],
                index: 'option1'
              },
              {
                value: found_option.option2,
                index: 'option2'
              }
            ];
          } else {
            return;
          }
        }

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                const opt = fieldset_options[input_i];
                input.classList.toggle('is-disabled', opt ? opt.isUnavailable : false);
              });
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }

    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        if (this.thumbnails) {
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });

          this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_thumbs.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        } else {
          this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
            if (thumb.dataset.group && thumb.dataset.group !== group) {
              thumb.classList.remove('is-active');
            }
          });
          selected_set_images.forEach(thumb => {
            thumb.classList.toggle('is-active', thumb.dataset.group === group);
          });
        }

      } else {

        if (!this.thumbnails) {
          let set_images = Array.from(selected_set_images).filter(function (element) {
            return element.dataset.group === group;
          });
          set_images.forEach(thumb => {
            thumb.parentElement.prepend(thumb);
          });
        }

      }
      if (!this.thumbnails) {
        setTimeout(() => {
          this.productSlider.onPaginationResize();
        }, 100);
      }
    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      return variants.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      if (this.variantData) return this.variantData;

      const byId = document.getElementById(`VariantJSON-${this.dataset.section}`);
      if (byId) {
        this.variantData = JSON.parse(byId.textContent);
        return this.variantData;
      }

      const fallback = this.querySelector('script[type="application/json"]');
      this.variantData = fallback ? JSON.parse(fallback.textContent) : [];
      return this.variantData;
    }
  }

  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');

      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.setAttribute('data-ajax-cart', 'true');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }
        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));

      const product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        document.body.classList.remove('open-cc--product');
        product_drawer.classList.remove('active');
        product_drawer.setAttribute('inert', '');
      }
      document.getElementById('Cart-Drawer')?.open();
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

(function () {
  function getOptionValueIds(root) {
    const ids = [];
    return ids;
  }
})();

let stickyAbortController = null;

document.addEventListener('change', async (e) => {
  const vs = e.target.closest('variant-selects');
  if (!vs) return;

  const isSticky = vs.id?.includes('--sticky') || vs.dataset.sticky === "1";
  if (!isSticky) return;

  try {
    await vs.updateMasterId?.();
    if (!vs.currentVariant?.id) return;

    const sectionId = vs.dataset.section;
    const baseUrl = vs.dataset.url;
    const url = `${baseUrl}?variant=${vs.currentVariant.id}&section_id=${sectionId}`;

    if (stickyAbortController) stickyAbortController.abort();
    stickyAbortController = new AbortController();

    const res = await fetch(url, {
      credentials: 'same-origin',
      signal: stickyAbortController.signal
    });

    const htmlText = await res.text();
    const doc = new DOMParser().parseFromString(htmlText, 'text/html');

    const srcStickyPrice = doc.getElementById(`price-${sectionId}--sticky`);
    const dstStickyPrice = document.getElementById(`price-${sectionId}--sticky`);
    if (srcStickyPrice && dstStickyPrice) {
      dstStickyPrice.innerHTML = srcStickyPrice.innerHTML;
      dstStickyPrice.classList.remove('visibility-hidden');
    }

    const srcStickyImg = doc.getElementById(`product-image-${sectionId}--sticky`);
    const dstStickyImg = document.getElementById(`product-image-${sectionId}--sticky`);
    if (srcStickyImg && dstStickyImg) {
      dstStickyImg.innerHTML = srcStickyImg.innerHTML;
    }

    const forms = document.querySelectorAll(`#product-form-${sectionId}, #product-form-installment`);
    forms.forEach((f) => {
      const idInput = f.querySelector('input[name="id"]');
      if (idInput) {
        idInput.value = vs.currentVariant.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  } catch (err) {
    if (err?.name === 'AbortError') return;
    console.warn('[STICKY FIX] failed:', err);
  }
});

function updateQuoteCount() {
  const quoteList = JSON.parse(localStorage.getItem('quoteList')) || [];
  const el = document.getElementById('quote-count');

  if (el) {
    el.textContent = quoteList.length;
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateQuoteCount();
  initQuoteButtons();
});

function initQuoteButtons() {
  if (window.decocasaQuoteInit) return;
  window.decocasaQuoteInit = true;

  function getOptionValue(name1, value1, name2, value2, name3, value3, targetNames) {
    const pairs = [
      { name: name1, value: value1 },
      { name: name2, value: value2 },
      { name: name3, value: value3 }
    ];

    const match = pairs.find(function (pair) {
      if (!pair.name) return false;
      return targetNames.includes(String(pair.name).trim().toLowerCase());
    });

    return match ? (match.value || '') : '';
  }

  function getVisibleQuantityNearButton(button) {
    const wrapper =
      button.closest('.product-add-to-cart-container') ||
      button.closest('.add_to_cart_holder') ||
      button.closest('form') ||
      document;

    const inputs = Array.from(
      wrapper.querySelectorAll('input.qty, input[name="quantity"]')
    ).filter(function (input) {
      return input.offsetParent !== null;
    });

    const qtyInput = inputs[0];
    return qtyInput ? parseInt(qtyInput.value || '1', 10) : 1;
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.add-to-quote');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    if (button.dataset.processing === 'true') return;
    button.dataset.processing = 'true';

    setTimeout(function () {
      button.dataset.processing = 'false';
    }, 500);

    const quantity = getVisibleQuantityNearButton(button);
    const unitPrice = parseInt(button.dataset.price || '0', 10);
    const isCeramic = button.dataset.isCeramic === 'true';

    const size = getOptionValue(
      button.dataset.option1Name,
      button.dataset.option1Value,
      button.dataset.option2Name,
      button.dataset.option2Value,
      button.dataset.option3Name,
      button.dataset.option3Value,
      ['ölçü', 'ebat', 'size']
    );

    const color = getOptionValue(
      button.dataset.option1Name,
      button.dataset.option1Value,
      button.dataset.option2Name,
      button.dataset.option2Value,
      button.dataset.option3Name,
      button.dataset.option3Value,
      ['renk', 'desen', 'color', 'pattern']
    );

    const variantId = String(button.dataset.variantId || '');
    let quoteList = JSON.parse(localStorage.getItem('quoteList')) || [];

    const existingIndex = quoteList.findIndex(function (item) {
      return String(item.variantId) === variantId;
    });

    if (existingIndex > -1) {
      quoteList[existingIndex].quantity += quantity;
      quoteList[existingIndex].lineTotal =
        quoteList[existingIndex].quantity * quoteList[existingIndex].unitPrice;

      if (!quoteList[existingIndex].paketM2) {
        quoteList[existingIndex].paketM2 =
          parseFloat(String(button.dataset.paketM2 || '0').replace(',', '.')) || 0;
      }

      if (!quoteList[existingIndex].size && size) {
        quoteList[existingIndex].size = size;
      }

      if (!quoteList[existingIndex].color && color) {
        quoteList[existingIndex].color = color;
      }
    } else {
      quoteList.push({
        title: button.dataset.title,
        url: button.dataset.url,
        variantId: variantId,
        sku: button.dataset.sku || '-',
        quantity: quantity,
        unitPrice: unitPrice,
        lineTotal: unitPrice * quantity,
        isCeramic: isCeramic,
        size: size,
        color: color,
        paketM2: parseFloat(String(button.dataset.paketM2 || '0').replace(',', '.')) || 0,
        image: button.dataset.image || ''
      });
    }

    localStorage.setItem('quoteList', JSON.stringify(quoteList));
    updateQuoteCount();
    alert('Ürün teklif listesine eklendi.');
  }, true);
}


